import constants from '../../../../ahm-constants';

const {
  URLS: {
    SALES: { CHOOSABLE_PICKER },
  },
} = constants;

const URL_TO_CLASSNAME_MAP = {
  [CHOOSABLE_PICKER]: 'choosablePicker',
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because index expression is not of type 'number'.
const getAdjustmentClassname = (pathname: string): string | undefined => URL_TO_CLASSNAME_MAP?.[pathname];

export default getAdjustmentClassname;
